import axios, { Method } from "axios";
import { Intermediario } from "./types/Intermediario";
import { CheckoutInitResponse, Configuratore, PrezzoCalcolato } from "./types/Configuratore";
import { ProdottoConfiguratore } from "./types/ProdottoConfiguratore";

const apiBaseUrl = process.env.REACT_APP_SERVER_API_URL;

const axiosConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

function loadIntermediario(id: string): Promise<Intermediario> {
  return axios
    .get(apiBaseUrl + `/intermediario/${encodeURIComponent(id)}`, axiosConfig)
    .then((response) => response.data);
}

function priceCalculation(body: Configuratore): Promise<PrezzoCalcolato> {
  const reqConfig = {
    ...axiosConfig,
    method: "POST" as Method,
    url: apiBaseUrl + "/preventivo",
    data: body,
  };
  return axios.request(reqConfig).then((response) => response.data);
}

function postCheckoutInit(body: Configuratore): Promise<CheckoutInitResponse> {
  const reqConfig = {
    ...axiosConfig,
    method: "POST" as Method,
    url: apiBaseUrl + "/checkout/init",
    data: body,
  };
  return axios.request(reqConfig).then((response) => response.data);
}

function getProdotto(id: string): Promise<ProdottoConfiguratore> {
  const reqConfig = {
    ...axiosConfig,
    method: "GET" as Method,
    url: apiBaseUrl + `/prodotto/${encodeURIComponent(id)}`,
  };
  return axios.request(reqConfig).then((response) => response.data);
}

export const Api = {
  // loadTariffe,
  loadIntermediario,
  priceCalculation,
  postCheckoutInit,
  getProdotto,
};
